import { createContext, useContext } from 'react';

// Lets a page ask the app shell to re-fetch the top nav (GET /nav/) without a
// full reload. The Navigation editor calls it after every saved change so the
// bar above it shows the new menu immediately. Defaults to a no-op, so a page
// rendered outside the shell (e.g. in a test) can still call it safely.
export const NavRefreshContext = createContext(() => Promise.resolve());

export const useNavRefresh = () => useContext(NavRefreshContext);
